import { Dialog, DialogContent, DialogTitle, IconButton, Box, Button } from '@mui/material';
import { X } from 'lucide-react';
import { ShareNetwork, Moon, Sparkle, StarIcon, SparkleIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import html2canvas from "html2canvas";
import { useRef } from 'react';
import { fullScreenButtonStyle } from '../../utils/buttonStyles';
import Spread from './Spread';
interface ShareReadingProps {
    open: boolean;
    onClose: () => void;
    cards: any[];
    question: string;
    type: string;
    snSentence?: string;
}

export default function ShareReading({ open, onClose, cards, question, type, snSentence }: ShareReadingProps) {
    const { t } = useTranslation();

    const ref = useRef<HTMLDivElement>(null);

    async function captureComponentAsImage(element: HTMLElement) {
        const canvas = await html2canvas(element, {
            backgroundColor: null, // keep transparency
            scale: 2, // higher quality
            useCORS: true,
        });

        const dataUrl = canvas.toDataURL("image/png");
        return dataUrl;
    }
    const shareWithMobile = async (imageUrl: string) => {
        console.log("mobile")
        await navigator.share({
            files: [new File([await (await fetch(imageUrl)).blob()], "luma.png", { type: "image/png" })],
            title: t('readingPage.shareTitle'),
            text: t('readingPage.shareText'),
        });
    }
    const shareWithUrl = async (imageUrl: string) => {
        console.log("url")
        if (!ref.current) return;

        // 1️⃣ Create a temporary download link
        const a = document.createElement("a");
        a.href = imageUrl;
        a.download = "lumatarot-reading.png";
        a.click();

        // 2️⃣ Open Instagram in a new tab
        window.open("https://www.instagram.com/", "_blank");
    }

    const handleShare = async () => {
        console.log("handleShare")
        if (!ref.current) return;
        const imageUrl = await captureComponentAsImage(ref.current);
        if (typeof navigator.share === 'function') {
            await shareWithMobile(imageUrl);
        } else {
            await shareWithUrl(imageUrl);
        }

    };

    // Get the first card for the main display
    const mainCard = cards[0];

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            fullScreen
            sx={{
                margin: 1,
                '& .MuiDialog-paper': {
                    backgroundColor: '#ECEAE5',
                    borderRadius: '5px',
                    border: '1px solid rgba(201, 173, 167, 0.4)',
                }
            }}

        >
            <DialogTitle
                sx={{
                    fontFamily: 'Playfair Display',
                    color: '#2B2E4A',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    pb: 2
                }}
            >
                <div className="flex items-center gap-2">
                    <ShareNetwork size={24} className="text-[#2B2E4A]" />
                    <span>{t('readingPage.shareReading')}</span>
                </div>
                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{
                        color: '#2B2E4A',
                        '&:hover': {
                            bgcolor: 'rgba(43, 46, 74, 0.1)'
                        }
                    }}

                >
                    <X size={20} />
                </IconButton>
            </DialogTitle>
            <DialogContent>            <Box
                sx={{
                    marginLeft: '5px',
                    paddingTop: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'min(calc(100vw - 80px), 70vh)',
                    height: 'min(calc(100vw - 80px), 70vh)',
                    textAlign: 'center',
                    color: '#2B2E4A',
                    backgroundColor: '#f0f0ea',
                    border: '1px solid rgba(201, 173, 167, 0.3)',

                }}
                ref={ref}
            >

                <div className="w-full h-full  mt-2 background-color-red p-1 pt-10">
                    {<Spread type={type} cards={cards}
                        setDrawnCards={() => { }}
                    />}
                </div>

                <div
                    style={{
                        fontFamily: 'Playfair Display',
                        fontSize: '1.1rem',
                        color: '#2B2E4A',
                        marginTop: 'auto',
                        paddingBottom: '50px',
                    }}
                >
                    <div
                        style={{
                            fontFamily: 'Playfair Display',
                            fontSize: '20px',
                            fontStyle: 'italic',
                            fontWeight: 400,
                            color: '#2B2E4A',
                            lineHeight: 1.6,
                            textAlign: 'center',
                            maxWidth: '100%',
                            display: 'none',
                        }}
                    >
                        {snSentence || question}

                    </div>
                    <div className="flex justify-center items-center  display-none">     <SparkleIcon
                        size={24}
                        weight="fill"
                        className="text-[#2B2E4A]  margin-top-auto "
                    /></div>
                    <div className="flex justify-center items-center pt-">  {t('readingPage.appName')}</div>
                    <br />
                    <span style={{ fontWeight: 400 }}></span>
                </div>
            </Box>
                <div className="flex flex-col items-center gap-3 mt-4">

                    <Button
                        onClick={(() => handleShare())}
                        sx={fullScreenButtonStyle}

                    >
                        {t('readingPage.shareReading')}
                    </Button>
                </div>
            </DialogContent>

        </Dialog>
    );
}

